export const branding = [
'default',
'international-monochrome',
'international-signature-en-monochrome',
'international-signature-en',
'international-signature-fr-monochrome',
'international-signature-fr',
'international',
'signature-monochrome',
'signature'
];